import React from "react";
import { useState,useEffect } from "react";
import { useLocation,useNavigate,useSearchParams, useParams  } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './classes/ManageReferrals.css';
import { DataGrid } from '@mui/x-data-grid';
import { configData } from "../config";
import { Link } from '@mui/material';
import { GridFilterInputValue } from '@mui/x-data-grid';
import Loading from './Loading';


const columns = [
    {
        field: 'name',
        headerName: 'Name',  
        headerClassName:'name_header',    
        flex:1,
        minWidth: 120,
        sortable:false,
    },
    {
        field: 'email',
        headerName: 'Email',   
        headerClassName:'email_header',  
        flex:1, 
        minWidth: 150,
        sortable:false,    
        renderCell: (params) => (
            <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
                {params.row.email}
            </Link>
        ),
    },
    {
        field: 'phone_number',
        headerName: 'Phone Number',   
        headerClassName:'phone_number_header',
        flex:1,
        minWidth: 140,
        sortable:false,
    },
    {
        field: 'country',
        headerName: 'Country',   
        headerClassName:'country_header',
        flex:1,
        minWidth: 120,
        sortable:false,
    },
    {
        field: 'date_of_app',
        headerName: 'Date of App',   
        headerClassName:'date_of_app_header',
        flex:1,
        minWidth: 100,
        sortable:false,
    },
    {
        field: 'created_date',
        headerName: 'Created Date',   
        headerClassName:'created_date_header',
        flex:1,
        minWidth: 100,
        sortable:false,
    },
    {
        field: 'salesperson',
        headerName: 'Sales Person',   
        headerClassName:'phone_number_header',
        flex:1,
        minWidth: 100,
        sortable:false,
    },
    {
        field: 'balance_amount',
        headerName: 'Balance Amount',   
        headerClassName:'balance_amount_header',
        flex:1,
        minWidth: 100,
        sortable:false,
    },
    {
    field: 'action',
    headerName: 'Action',
    cellClassName:'action_column',headerClassName:'action_header',
    sortable: false,
    filterable: false, // not filterable
    flex:1,
    minWidth: 150,
    renderCell: (params) => (
      <Link href={params.row.cashout_link} target="_blank" rel="noopener noreferrer" style={{ textAlign: "center"}} className="reddbtnn cahoutbtn" >
        {params.row.linkText || 'Cash Out'}
      </Link>
    ),
  },
];


const ManageReferrals = () => {

    const initialReferralsForm = {
        fname:'',
        country:'',
        lname:'',
        salesperson:'',
        email:'',
        balance_amount:'',
    }

    // const headers = [
    //     "Name",
    //     "Email",
    //     "Phone Number",
    //     "Country",
    //     "Date of App",
    //     "Created Date",
    //     "Sales Person",
    //     "Balance Amount",
    //     "Actions"
    // ];

    const [isLoading, setIsLoading] = useState(true);
    const [formData, setFormData] = useState(initialReferralsForm);
    const [countrieslist, setCountriesList] = useState({});
    const[salespersonList, setSalespersonList] = useState({});

    const [rows, setRows] = React.useState([]);
    const [rowCount, setRowCount] = React.useState(0);
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
    const [sortModel, setSortModel] = React.useState([]);
    const [filterModel, setFilterModel] = React.useState({ items: [] });

    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const { id } = useParams(); 
   const location  = useLocation();
    const successMessage = location.state?.message; // Access the message
    window.history.replaceState({}, '');
    const loggedin_uid = localStorage.getItem('drupal_uid');

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
        
    };

    useEffect(() => { 
        Promise.all([
            retrieveCountriesList(),
            getsalespersonlist(),
            ]).then(() => {
     
                setIsLoading(false);
            })   
    },[]); 

    React.useEffect(() => {
        const fetchData = async () => {
        // Simulate API call to your server
        // In a real application, replace this with your actual fetch logic
            try {
                const response = await fetch(app_url+'referral/getmanagereferralslist', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                       page: paginationModel.page,
                       pageSize: paginationModel.pageSize,
                       sortModel,
                      filterModel,
                    formData:formData
                    }),
                });
                const data = await response.json();
                   console.log(data.data.rows);
                   setRows(data.data.rows);
                   setRowCount(data.data.totalRowCount); // Server should return totalRowCount
            }  catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setIsLoading(false); // Set loading to false after fetch completes (success or error)
            }
        };
        fetchData();
    },[paginationModel, sortModel, filterModel]); 

    async function retrieveCountriesList() {
        try {
        
            const countrieslistresponse = await fetch(app_url + 'smwwcountries/getcountrieslist', {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const countrieslistdata = await countrieslistresponse.json();
            const countrieslist = {};
            Object.keys(countrieslistdata.data.result).forEach(function(key) {
                countrieslist[key] = countrieslistdata.data.result[key];
            });
            setCountriesList(countrieslist);
        } catch (error) {
            console.error(error);
        }finally {
            
        }
    }

    async function getsalespersonlist() {
        try {
            const response = await fetch(
                app_url+'user/getsalespersonlist',
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setSalespersonList(responsedata.data.result);
            } 
        } catch (error) {
            console.error(error);
        }finally {
            
        }    
    }



    const handleSubmit = async (e) => {
        e.preventDefault();
        setPaginationModel({
                 page: 0,
                    pageSize: 50,
                 });
        try {
            setIsLoading(true);
            const response = await fetch(app_url+'referral/getmanagereferralslist', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                   page: 0,
                   pageSize: 50,
                   sortModel,
                  filterModel,
                formData:formData
                }),
                });
            const data = await response.json();
           
               setRows(data.data.rows);
               setRowCount(data.data.totalRowCount); // Server should return totalRowCount
        }  catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
        }
    
    }; 

    const handleExport = async (e) => {
    e.preventDefault(); // stop page reload
       
     try {
        setIsLoading(true);
      const response = await fetch(app_url+'referral/getmanagereferralsexport', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          
          formData:formData
        }),
      });
      const data = await response.json();
      const csvUrl = data.data.csvUrl;
      const urlParts = csvUrl.split('/');
        const fileName = urlParts[urlParts.length - 1];
                const link = document.createElement('a');
                link.href = csvUrl;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
      
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }


  };
    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main" className="manage-referrals-main">
                    <Helmet><title>Manage Referrals</title></Helmet>
                    
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="manage-referrals-container">
                            <h1>Manage Referrals</h1>
                            {successMessage && (
                        <div className="set-message-done">
                          <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {successMessage}
                        </div>
                        )}
                            <form>
                                <div className="search-form">
                                    <fieldset>
                                        <legend>
                                            <h3 style={{paddingLeft: "0px", borderLeft: "0px"}}>Search</h3>
                                        </legend>
                                        <div style={{width:"100%"}}>
                                            <div className="referrals-filter">
                                                <div style={{marginBottom: "20px"}}>
                                                    <label>First Name</label>
                                                    <input 
                                                        type="text" 
                                                        name="fname" 
                                                        value={formData.fname}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div>
                                                    <label>Country:</label>
                                                    <select 
                                                        id="country" 
                                                        name="country" 
                                                        className="referrals-select"
                                                        value={formData.country}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="">ALL</option>
                                                        {Object.keys(countrieslist).map(item => {
                                                            return <option key={countrieslist[item].label} value={countrieslist[item].label}>
                                                                {countrieslist[item].label}
                                                            </option>
                                                        })}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="referrals-filter">
                                                <div style={{marginBottom: "20px"}}>
                                                    <label>Last Name</label>
                                                    <input 
                                                        type="text" 
                                                        name="lname" 
                                                        value={formData.lname}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div>
                                                    <label>Salesperson:</label>
                                                    <select 
                                                        id="salesperson" 
                                                        name="salesperson" 
                                                        value={formData.salesperson}
                                                        onChange={handleChange}
                                                        className="referrals-select"
                                                    >
                                                        <option value="">All</option>
                                                        {salespersonList.length > 0 && (
                                                        <>
                                                            {salespersonList.map((item, index) => {
                                                                return <>
                                                                {item['uid'] != null && (
                                                                    <><option value={item['uid']}>{item['name']}</option></>
                                                                )}
                                                            </>
                                                            })}  
                                                        </>
                                                        )}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="referrals-filter">
                                                <div style={{marginBottom: "20px"}}>
                                                    <label>Email</label>
                                                    <input 
                                                        type="text" 
                                                        name="email" 
                                                        value={formData.email}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div>
                                                    <label>Referral Balance Amount:</label>
                                                    <select 
                                                        id="balance_amount" 
                                                        name="balance_amount" 
                                                        value={formData.balance_amount}
                                                        onChange={handleChange}
                                                        className="referrals-select"
                                                    >
                                                        <option value="">All</option>
                                                        <option value="50">Below $50</option>
                                                        <option value="51">$51 and over</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div style={{clear:"both"}}></div><br />
                                        
                                            <input
                                                type="submit" 
                                                name="submit" 
                                                value="Submit"
                                                onClick={handleSubmit} 
                                                style={{marginRight: "5px"}}
                                            />
                                            <a href="/manage-referrals">
                                                <input type="button" name="reset" value="Reset" />
                                            </a>
                                            <input 
                                                type="submit" 
                                                name="export" 
                                                value="Export" 
                                                // onClick={handleExport} 
                                                style={{float:"right"}} 
                                                onClick={handleExport}
                                            />
                                        </div>
                                    </fieldset>
                                </div>
                            </form>
                            <div className="page-view-myorder">
                                <div className="panel panel-default">
                                    <div className="panel-body">
                                        <table className="">
                                            <DataGrid
                                                rows={rows}
                                                columns={columns}
                                                rowCount={rowCount}
                                                paginationMode="server"
                                                sortingMode="server"
                                                filterMode="server"
                                                paginationModel={paginationModel}
                                                onPaginationModelChange={setPaginationModel}
                                                sortModel={sortModel}
                                                onSortModelChange={setSortModel}
                                                filterModel={filterModel}
                                                onFilterModelChange={setFilterModel}
                                                pageSizeOptions={[5, 10, 25,50]}
                                                getRowId={() => crypto.randomUUID()}
                                                getRowHeight={() => 'auto'}
                                                disableColumnFilter 
                                                // disableColumnResize={true}
                                            />
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="right"></div>
                </div>
            )} 
        </>
    );
};
export default ManageReferrals;